import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { CLessonInCourse, InferValuesTypes } from '@yandex-int/k-common/typings';

import * as actions from './actions';

export enum COURSE_VIEW_LESSONS_TABS {
    COMPLETE = 'complete',
    ACTIVE = 'active',
    DRAFTS = 'drafts',
}

export enum COURSE_VIEW_DISPLAY_MODE {
    LIST = 'list',
    CALENDAR = 'calendar',
}

export enum COURSE_VIEW_TABS {
    SKILLS_STATS = 'skills_stats',
    LESSONS = 'lessons',
}

export interface CourseLessonsData {
    sortKey: number | null;
    canLoadMoreLessons: boolean;
    loadingStatus: LOADING_STATUSES;
    lessons: Array<CLessonInCourse>;
}

export type LessonsData = Record<number, CourseLessonsData>;

export interface CourseViewStore {
    statisticsModalClosed: boolean;
    drafts: LessonsData;
    completedLessons: LessonsData;
    activeLessons: LessonsData;
    assignedLessons: LessonsData;
    isAssignedLessonEvaluable: boolean;
}

export type CourseViewActions = ReturnType<InferValuesTypes<typeof actions>>;
